export default "__VITE_ASSET__agPW3i4W__"